import { get, post } from '../util/axios';

export default {
  get: async () => {
    const url = '/api/torrent/get';
    return await get(url);
  }
};
